"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = apiResponse;

var _merge = require("lodash/merge");

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Simply puts last api response action type into state, along with error message if applicable.
// Allows components to respond to async actions they have initiated (eg show error).

if (!global._babelPolyfill) {
    require('babel-polyfill');
};
function apiResponse() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { actionType: null, error: null, statusCode: null };
    var action = arguments[1];

    if (action.apiResponse) {
        return {
            actionType: action.type,
            error: action.error,
            statusCode: action.statusCode
        };
    } else if (action.apiRequest) {
        return {
            actionType: null,
            error: null,
            statusCode: null
        };
    }

    return state;
}